import { ReportMedia } from "@shared/lib/types/reports";
import { formatData } from "@shared/lib/utils/formatData";
import { Eye, Heart, MessageCircle, Share2, TrendingUp } from "lucide-react";
import styles from "./PerformanceOverview.module.scss";

interface PerformanceOverviewProps {
  reportMedia: ReportMedia;
}

export function PerformanceOverview({ reportMedia }: PerformanceOverviewProps) {
  const mediaData = reportMedia.mediaData;
  const commentData = reportMedia.commentData;

  const views = mediaData?.views || 0;
  const likes = mediaData?.likes || 0;
  const comments = mediaData?.comments || 0;
  const shares = mediaData?.shares || 0;
  const engRate = mediaData?.engRate || 0;

  const totalComments = commentData?.noOfCommentsAnalysed || comments;
  const relevantComments = commentData?.noOfRevelantComment || 0;
  const intentComments = commentData?.noOfIntentToBuy || 0;

  return (
    <div className={styles.container}>
      <h4 className={styles.title}>Performance Overview</h4>
      <div className={styles.metricsGrid}>
        <div className={styles.metricCard}>
          <Eye size={16} className={styles.viewsIcon} />
          <div className={styles.metricLabel}>Views</div>
          <div className={styles.metricValue}>{formatData(views)}</div>
        </div>
        <div className={styles.metricCard}>
          <Heart size={16} className={styles.likesIcon} />
          <div className={styles.metricLabel}>Likes</div>
          <div className={styles.metricValue}>{formatData(likes)}</div>
        </div>
        <div className={styles.metricCard}>
          <MessageCircle size={16} className={styles.commentsIcon} />
          <div className={styles.metricLabel}>Comments</div>
          <div className={styles.metricValue}>{formatData(comments)}</div>
        </div>
        <div className={styles.metricCard}>
          <Share2 size={16} className={styles.sharesIcon} />
          <div className={styles.metricLabel}>Shares</div>
          <div className={styles.metricValue}>{formatData(shares)}</div>
        </div>
      </div>

      <div className={styles.bottomGrid}>
        <div className={styles.engagementCard}>
          <div className={styles.engagementContent}>
            <div className={styles.metricLabel}>Engagement Rate</div>
            <div className={styles.metricValue}>{formatData(engRate)}%</div>
          </div>
          <TrendingUp size={20} className={styles.trendingIcon} />
        </div>
        {/* <div className={styles.commentBreakdownCard}>
          <div className={styles.metricLabel}>Comment Breakdown</div>
          <div className={styles.commentBreakdown}>
            <div className={styles.commentItem}>
              <span className={styles.commentValue}>
                {formatData(totalComments)}
              </span>
              <span className={styles.commentLabel}>All</span>
            </div>
            <div className={styles.divider}></div>
            <div className={styles.commentItem}>
              <span
                className={`${styles.commentValue} ${styles.relevantValue}`}
              >
                {formatData(relevantComments)}
              </span>
              <span className={styles.commentLabel}>Relevant</span>
            </div>
            <div className={styles.divider}></div>
            <div className={styles.commentItem}>
              <span className={`${styles.commentValue} ${styles.intentValue}`}>
                {formatData(intentComments)}
              </span>
              <span className={styles.commentLabel}>Intent</span>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
